import React from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import { grid } from '_/styles';

export const Loader = styled(props => (
  <ContentLoader
    title="Carregando documento..."
    backgroundColor="#e0e7ec"
    foregroundColor="#f2f5f7"
    {...props}
  />
))``;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1040px;
  min-width: 840px;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 456px;

  &:last-child {
    max-width: 400px;
    margin-left: ${grid.large};
  }
`;

export const Box = styled.div`
  border: 1px solid #e0e7ec;
  display: flex;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  height: 96px;
  margin-bottom: 16px;
`;
export const Group = styled.div`
  margin-bottom: 20px;
  position: relative;

  ${({ noMargin }) => noMargin && 'margin: 0;'}
`;
